import { useQuery, useMutation, invalidateKeys } from '../lib/query';
import { listFeedback, deleteFeedback } from '../services/feedback';

const KEY = 'feedback';

export const useFeedbackList = (params) =>
  useQuery({ queryKey: [KEY, params], queryFn: () => listFeedback(params) });

export const useDeleteFeedback = (opts = {}) =>
  useMutation({
    mutationFn: (id) => deleteFeedback(id),
    onSuccess: () => { invalidateKeys([KEY]); opts.onSuccess?.(); },
    onError: opts.onError,
  });
